/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificaPushSelezioneForm { 
    /**
     * Comune di perimetro. Per un OP_COMUNE che ne gestisce piu\' di uno e\' obbligatorio; se ne gestisce uno solo e\' il default. Per un SUPERADMIN e\' opzionale: se presente restringe la scelta ai cittadini con una pratica in quel Comune, se assente non c\'e\' alcun vincolo.
     */
    comune_id?: string;
    /**
     * Cittadini destinatari: almeno uno, al massimo 50 id distinti (i duplicati sono ridotti a uno).
     */
    user_ids: Array<string>;
    /**
     * Titolo della notifica, mostrato in grassetto sul dispositivo.
     */
    titolo: string;
    /**
     * Corpo del messaggio.
     */
    messaggio: string;
}

